import _ from 'lodash';

export const excelSheets = [
  {
    original_name: 'DAILY',
    name: 'facebook.sheet.daily',
    selected: true,
    graphic_name: 'DAILY_CHART',
  }, {
    original_name: 'DAILY_CAMPAIGN',
    name: 'facebook.sheet.dailyCampaign',
    selected: false,
    graphic_name: null,
  },
  {
    original_name: 'CREATIVE',
    name: 'facebook.sheet.creativeCampaign',
    selected: true,
    graphic_name: null,
  },
  {
    original_name: 'CREATIVE_ONLY',
    name: 'facebook.sheet.creative',
    selected: false,
    graphic_name: 'CREATIVE_ONLY_CHART',
  },
  {
    original_name: 'CREATIVE_CUSTOMERS',
    name: 'facebook.sheet.creativeCustomers',
    selected: false,
    graphic_name: null,
  }, {
    original_name: 'CREATIVE_AD_SET',
    name: 'facebook.sheet.creativeAdSet',
    selected: false,
    graphic_name: null,
  }, {
    original_name: 'CREATIVE_URL',
    name: 'facebook.sheet.creativeUrl',
    selected: false,
    graphic_name: null,
  }, {
    original_name: 'CAMPAIGN',
    name: 'facebook.sheet.campaign',
    selected: false,
    graphic_name: 'CAMPAIGN_CHART',
  }, {
    original_name: 'CAMPAIGN_AD_SET',
    name: 'facebook.sheet.campaignAdSet',
    selected: false,
    graphic_name: null,
  }, {
    original_name: 'AD_SET',
    name: 'facebook.sheet.adSet',
    selected: false,
    graphic_name: 'AD_SET_CHART',
  }, {
    original_name: 'CUSTOMERS',
    name: 'facebook.sheet.customers',
    selected: false,
    graphic_name: null,
  }, {
    original_name: 'AD_GOALS',
    name: 'facebook.sheet.adGoals',
    selected: false,
    graphic_name: null,
  }, {
    original_name: 'GENDER_AGE',
    name: 'facebook.sheet.genderAge',
    selected: false,
    graphic_name: null,
  }, {
    original_name: 'PLATFORM',
    name: 'facebook.sheet.platform',
    selected: false,
    graphic_name: null,
  }, {
    original_name: 'AREA',
    name: 'facebook.sheet.area',
    selected: false,
    graphic_name: null,
  }, {
    original_name: 'MONTHLY',
    name: 'facebook.sheet.monthly',
    selected: false,
    graphic_name: 'MONTHLY_CHART',
  }, {
    original_name: 'RAW_DATA',
    name: 'facebook.sheet.rawData',
    selected: true,
    graphic_name: null,
  }
]

export const hideRequiredFields = [
  {
    "name": "campaign_name",
    "expression": "campaign_name",
    "format": "STRING",
    "type": "DEFAULT",
    "indexNumber": 0,
  },
  {
    "name": "adgroup_name",
    "expression": "adgroup_name",
    "format": "STRING",
    "type": "DEFAULT",
    "indexNumber": 0,
  },
  {
    "name": "ad_name",
    "expression": "ad_name",
    "format": "STRING",
    "type": "DEFAULT",
    "indexNumber": 0,
  },
]

export const requiredFields = [
  {
    "name": "impressions",
    "expression": "impressions",
    "format": "INTEGER",
    "type": "DEFAULT",
    "indexNumber": 1,
  },
  {
    "name": "clicks",
    "expression": "clicks",
    "format": "INTEGER",
    "type": "DEFAULT",
    "indexNumber": 2,
  },
  {
    "name": "click_through_rate",
    "expression": "click_through_rate",
    "format": "PERCENT",
    "type": "DEFAULT",
    "indexNumber": 3,
  },
  {
    "name": "cost_per_clicks",
    "expression": "cost_per_clicks",
    "format": "DECIMAL",
    "type": "DEFAULT",
    "indexNumber": 4,
  },
  {
    "name": "cost",
    "expression": "cost",
    "format": "INTEGER",
    "type": "DEFAULT",
    "indexNumber": 5,
  }
]